import './Avatar.css';
export default {
    "white": "#fff",
    "neutral-100": "#f8f7fa",
    "neutral-200": "#efedf2",
    "neutral-300": "#dddae3",
    "neutral-400": "#c1bdc7",
    "neutral-500": "#918d99",
    "neutral-600": "#716b7a",
    "neutral-700": "#585163",
    "neutral-800": "#3a3247",
    "neutral-900": "#261b36",
    "neutral-1000": "#13002d",
    "root": "Avatar_root__iv12j",
    "image": "Avatar_image__iv12j",
    "small": "Avatar_small__iv12j",
    "text": "Avatar_text__iv12j",
    "medium": "Avatar_medium__iv12j",
    "large": "Avatar_large__iv12j",
    "xlarge": "Avatar_xlarge__iv12j",
    "default": "Avatar_default__iv12j",
    "control": "Avatar_control__iv12j"
};
